<template>
  <div class="pt-safe bg-topbar-background border-b border-content-background">
    <div class="px-2 sm:px-4 py-2 sm:py-3 flex text-n-0 items-center h-14">
      <div class="flex-1 flex items-center shrink min-w-0">
        <slot name="left">
          <div v-if="showBack" class="text-n-0 cursor-pointer" @click="$emit('back')">
            <div class="p-3 -m-3">
              <l-icon name="lucide/arrow-left" size="medium" />
            </div>
          </div>
        </slot>
      </div>
      <div class="flex justify-center">
        <slot name="center" />
      </div>
      <div class="flex-1 flex justify-end text-n-0 items-center gap-2">
        <l-button
          v-if="!isConnected"
          icon="lucide/wifi-off"
          size="small"
          color="red"
          class="rounded-full"
        />
        <div v-if="showClose" class="sm:hidden">
          <l-button size="medium" icon="close" type="text" color="white" @click="$emit('close')" />
        </div>
        <slot name="right" />
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { storeToRefs } from 'pinia'

import { LButton, LIcon } from '@last/core-ui/paprika'

import { useStatusStore } from '@/store/status'

type Props = {
  showBack?: boolean
  showClose?: boolean
}

withDefaults(defineProps<Props>(), {
  showBack: false,
  showClose: false
})

defineEmits<{
  back: []
  close: []
}>()

const { isConnected } = storeToRefs(useStatusStore())
</script>
